const TFL_PARAM_START = 'tfl=';
const QUESTION_MARK = '?';
const AMPERSAND = '&';

const getIsLink = (str) => {
    return str.startsWith('http://') || str.startsWith('https://');
};

export const sanitizeUrlWithTFL = (tflString, linkUrl) => {
    if (getIsLink(tflString)) {
        return tflString;
    }

    const tflStart = `${tflString.indexOf(TFL_PARAM_START) === -1 ? TFL_PARAM_START : ''}`;
    const paramAddition = `${linkUrl.indexOf(QUESTION_MARK) === -1 ? QUESTION_MARK : AMPERSAND}`;
    return `${linkUrl}${paramAddition}${tflStart}${tflString}`;
};

const wrapWithTFL = (linkUrl, makeTFL, component) => {
    if (typeof linkUrl !== 'string' || typeof makeTFL !== 'function') {
        return linkUrl;
    }

    const config = { url: linkUrl };
    if (component) {
        config.component = component;
    }

    return sanitizeUrlWithTFL(makeTFL(config), linkUrl);
};

export default wrapWithTFL;
